import { useTranslation } from 'react-i18next';
import RatingItem from '../RatingItem';
import { IRatingCardProps } from '../../interface/ratingsInterface';

function RatingCard({ ratings, average, containerClassName}: IRatingCardProps) {
    const { t } = useTranslation();
    
    return (
        <div className={`pr-0 lg:pr-6 bg-[#F7F8FC] w-full rounded text-[12px] h-full ${containerClassName}`}>
            <div className="flex h-full relative">      
                <div className="w-full lg:w-4/5 lg:pr-4">

                    <div className="lg:hidden absolute top-0 left-0 w-full">
                        <div className="w-full py-3 px-4 bg-white rounded flex flex-row items-center justify-center gap-4">                    
                            <p className="text-[12px] text-center text-[#51525F] font-poppins font-normal leading-[140%]">
                                {t('components.ratings.averageRating')}
                            </p>
                            <span className="text-[24px] font-semibold text-[#51525F] font-poppins">
                                {(average ?? 0).toFixed(2)}
                            </span>
                        </div>
                    </div>

                    <div className="flex flex-row lg:flex-col gap-4 lg:items-center items-start h-full overflow-x-auto hide-scrollbar-mobile">
                        {ratings.map((rating, index) => (
                            <RatingItem 
                                key={index} 
                                rating={rating} 
                                responsive={true}
                            />
                        ))}
                    </div>
                </div>
                
                <div className="hidden lg:block w-1/5 h-full sticky top-0">
                    <div className="w-full h-full sm:min-h-[284px] px-6 py-4 bg-white rounded flex flex-col items-center justify-center gap-6">
                        <span className="text-[24px] font-semibold text-[#51525F] font-poppins">
                            {(average ?? 0).toFixed(2)}
                        </span>                   
                        <p className="w-[60%] mx-auto text-[12px] text-center text-[#51525F] font-poppins font-normal leading-[140%]">
                            {t('components.ratings.averageRating')}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default RatingCard;